import React from "react";
import { useState } from "react";
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";
import "./Faq.scss";
import Information from "../../svg/information.svg";
import BlockContent from "../block-content";

export default function Faq({faqs}) {

  return (
    <section id="faq">
      <div className="unsureForm--chooserIcon">
        <Information />
      </div>
      <div className="unsureForm--chooserIcon--background" />
      <div className="card faq__cardWrapper">
        <div className="faq__header">
          <h1>{faqs.title}</h1>

          <div className="faq__wrapper">
            <AnimateSharedLayout>
              <motion.ul className="faq__ul" layout initial={{ borderRadius: 25 }}>
                {faqs._rawFaqItems.map(faq => (
                  <Item key={faq._key} headline={faq.question} data={faq.answer} />
                ))}
              </motion.ul>
            </AnimateSharedLayout>
          </div>
        </div>
      </div>
    </section>
  );
}

const Item = ({ headline, data }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <>
      <motion.li layout onClick={toggleOpen} initial={{ borderRadius: 10 }}>
        <motion.div className="faq__headerGrid" layout>
          <div className="faq__avatar"></div>
          <h2>{headline}</h2>
        </motion.div>
        <AnimatePresence>{isOpen && <Content data={data} />}</AnimatePresence>
      </motion.li>
    </>
  );
};

const Content = ({ data }) => {
  return (
    <motion.div layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <BlockContent blocks={data || []} />
    </motion.div>
  );
};

